import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import knightsFiveTrainersData from '../data/KnightsFive';
import './KnightsFive.css';

const KnightsFiveTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(knightsFiveTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Knights Five trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/knight-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/knights-train-categories');
    };

    return (
        <div className="knights-five-trainers-container">
            <div className="knights-five-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button knights-five-back"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="knights-five-trainers-header">
                <div className="header-content">
                    <h1>Regional Lords & Ancient Bloodlines</h1>
                    <p>Train with the noble rulers and keepers of ancient traditions</p>
                    <div className="category-stats">
                        <span className="stat-badge knights-five-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge knights-five-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge knights-five-badge">Category: Noble Heritage</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="knights-five-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="knight-five-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--knight-five-primary-color': trainer.color,
                            '--knight-five-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="knight-five-trainer-image-section">
                            <div
                                className="knight-five-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="noble-gleam-effect"></div>
                                <div className="experience-badge knight-five-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="knight-five-trainer-info-section">
                            <h3 className="knight-five-trainer-name">{trainer.name}</h3>
                            <h4 className="knight-five-trainer-title">{trainer.title}</h4>
                            <p className="knight-five-trainer-specialization">{trainer.specialization}</p>
                            <p className="knight-five-trainer-description">{trainer.intro}</p>

                            <div className="knight-five-trainer-details">
                                <div className="detail-item knight-five-detail">
                                    <div className="detail-icon">👑</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item knight-five-detail">
                                    <div className="detail-icon">🏰</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="knights-five-trainers-footer">
                <div className="knights-five-info">
                    <h3>Noble Heritage Philosophy</h3>
                    <div className="knights-five-benefits-grid">
                        <div className="knight-five-benefit-item">
                            <div className="benefit-icon">🌟</div>
                            <div>
                                <strong>Legacy Building</strong>
                                <p>Young knight conditioning that honors the past while forging the future</p>
                            </div>
                        </div>
                        <div className="knight-five-benefit-item">
                            <div className="benefit-icon">🏰</div>
                            <div>
                                <strong>Regional Leadership</strong>
                                <p>Noble conditioning for ruling lands and protecting ancient territories</p>
                            </div>
                        </div>
                        <div className="knight-five-benefit-item">
                            <div className="benefit-icon">🗡️</div>
                            <div>
                                <strong>Ancient Heritage</strong>
                                <p>Tribal strength training that connects modern knights to ancient warriors</p>
                            </div>
                        </div>
                        <div className="knight-five-benefit-item">
                            <div className="benefit-icon">🤝</div>
                            <div>
                                <strong>Cultural Bridge</strong>
                                <p>Eastern wisdom training that proves chivalry transcends all boundaries</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnightsFiveTrainers;